import type { BookService, ProjectDto, ProjectServiceDto } from '@fiverr-private/book_publishing_types';

const NEXT_SERVICE: Record<BookService, BookService> = {
    writing: 'editing',
    editing: 'design',
    design: 'promotion',
    illustration: 'formatting',
    formatting: 'promotion',
    promotion: 'promotion',
    audiobook: 'promotion',
};

export const getRelevantService = (project: ProjectDto) => {
    const latestHiredService: ProjectServiceDto | undefined = project.services
        .filter((service) => service.status === 'hired')
        .sort((a, b) => b.displayOrder - a.displayOrder)[0];

    if (!latestHiredService) {
        return project.defaultServiceSlug;
    }

    return NEXT_SERVICE[latestHiredService.slug] ?? project.defaultServiceSlug;
};
